import { ImmutableRecord } from './records';
import { StateRecord } from '@mode/shared/contract-common';

const MENU_OPTION_DEFAULTS: MenuOptionState<MenuOptionId.AllTypes> = {
  token: '',
  id: null,
  enabled: false, // allowed given the app state
  granted: false, // allowed given the user
  name: '',
  href: '',
};

interface MenuOptionState<T extends MenuOptionId.AllTypes> extends StateRecord {
  readonly id: T;
  readonly enabled?: boolean;
  readonly granted?: boolean;
  readonly name?: string;
  readonly href?: string;
}

// eslint-disable-next-line @typescript-eslint/no-namespace
export namespace MenuOptionId {
  export const enum Report {
    Clone = '[Report] Clone',
    CloneLoggedOut = '[Report] CloneLoggedOut',
    CreateShortcut = '[Report] CreateShortcut',
    Delete = '[Report] Delete',
    Edit = '[Report] Edit',
    Embed = '[Report] Embed',
    Export = '[Report] Export',
    ExportAll = '[Report] ExportAll',
    ExportCsv = '[Report] ExportCsv',
    ExportPdf = '[Report] ExportPdf',
    ExportPdfDownload = '[Report] ExportPdfDownload',
    Fullscreen = '[Report] Fullscreen',
    Save = '[Report] Save',
    Share = '[Report] Share',
    SimpleShare = '[Report] SimpleShare',
    ManageReport = '[Report] ManageReport',
    Move = '[Report] Move',
    Rename = '[Report] Rename',
    Refresh = '[Report] Refresh',
    Run = '[Report] Run',
    Schedule = '[Report] Schedule',
    Settings = '[Report] Settings',
    Subscribe = '[Report] Subscribe',
    Sync = '[Report] Sync',
    ViewDetails = '[Report] ViewDetails',
    ViewGithub = '[Report] ViewGithub',
    ViewReport = '[Report] ViewReport',
    StarReport = '[Report] StarReport',
  }

  export const enum Definition {
    Create = '[Definition] Create',
    Settings = '[Definition] Settings',
    Delete = '[Definition] Delete',
    Sync = '[Definition] Sync',
    ViewGithub = '[Definition] ViewGithub',
  }

  export type AllTypes = MenuOptionId.Report | MenuOptionId.Definition;
}

export class MenuOptionRecord<T extends MenuOptionId.AllTypes> extends ImmutableRecord<MenuOptionState<T>> {
  constructor(params?: Partial<MenuOptionState<T>>) {
    super(Object.assign({}, MENU_OPTION_DEFAULTS, params));
  }

  get id(): T {
    return this.get('id');
  }

  isEnabled(): boolean {
    return this.get('enabled');
  }

  isGranted(): boolean {
    return this.get('granted');
  }

  get enabled(): boolean | undefined {
    return this.get('enabled');
  }

  get href(): string {
    return this.get('href');
  }
}
